import React from "react";

import { cn } from "../../../lib/utils";

import "./Skeleton.css";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
	return (
		<div
			data-slot="skeleton"
			className={cn("skeleton h-6 w-full bg-gradient-to-r from-neutral-2 via-neutral-1 to-neutral-2", className)}
			{...props}
		/>
	);
}

export { Skeleton };
